import axios from "axios";
export default {
    validatePassword: (password) => axios.post("/Account/ValidatePassword", `old_password=${password}`),
    changePassword: (model) => axios.post("/Account/ChangePassword", model)
};
